<div *ngFor="let downtime of upcomingDowntimes" class="downtime-banner">
  <div class="banner-content">
    <mat-icon class="banner-icon">warning</mat-icon>
    <div class="banner-text">
      <strong>Scheduled Maintenance:</strong>
      {{ downtime.description }}
      <span class="banner-times">
        | Start: {{ downtime.startDateTime | date:'MM/dd/yyyy hh:mm a' }}
        | End: {{ downtime.endDateTime | date:'MM/dd/yyyy hh:mm a' }}
      </span>
    </div>
    <button mat-icon-button class="banner-close" (click)="dismiss(downtime.id)" aria-label="Dismiss">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
